export default "__VITE_ASSET__C2jM$Fdb__"